import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Box,
} from "@mui/material";

// --- This is the updated interface ---
interface DeleteConfirmationModalProps {
  open: boolean;
  message?: string;
  handleClose: () => void;
  handleConfirm: () => void;
  // --- New Props for the optional reason field ---
  reason?: string;
  onReasonChange?: (reason: string) => void;
  showReasonField?: boolean;
  isAccoutModule?: boolean; // New prop to indicate if it's for Account module
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  open,
  message = "Are you sure you want to proceed? This action cannot be undone.",
  handleClose,
  handleConfirm,
  // Destructure the new props with default values
  reason,
  onReasonChange,
  showReasonField = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ fontWeight: "bold" }}>Confirm Action</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>

        {/* --- Conditionally Rendered Reason Field --- */}
        {showReasonField && (
          <Box mt={2}>
            <TextField
              fullWidth
              size="small"
              label="Reason for deletion * "
              value={reason || ""}
              onChange={e => onReasonChange?.(e.target.value)}
              variant="outlined"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button
          disabled={showReasonField && (!reason || reason.trim() === "")}
          onClick={handleConfirm}
          variant="contained"
          color="error" // Using 'error' color for delete actions is common
          sx={{
            backgroundColor: "#FF1F1F",
            "&:hover": { backgroundColor: "rgb(191, 44, 44)" },
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
